import { ApDataGrid } from '@uipath/portal-shell-react';
import React from 'react';

import useTenantTagPropertiesViewModel from './TenantTagPropertiesViewModel';

const TenantTagsPropertiesComponent: React.FC = () => {

    const { apGridRef } = useTenantTagPropertiesViewModel();

    return (
        <div
            style={{ width: '100%' }}
            data-cy='tenant-tags-properties-grid'>
            <ApDataGrid
                data-cy="ap-data-grid"
                ref={apGridRef}
            />
        </div>
    );
};

export default TenantTagsPropertiesComponent;
